import React, { useContext, useState } from "react";

import { LookupContext } from "@gp/components";
import { openTournamentStatistics } from "@utils";
import classNames from "classnames";

export default function TournamentStatisticsButton(props: {
	tournament: {
		id: string;
	};
	isAdditionalOfferVisible?: boolean;
	customBtnClassName?: string;
	customIconClassName?: string;
}) {
	const { tournament, customBtnClassName, customIconClassName } = props;
	const { tournaments } = useContext(LookupContext);

	const [isHover, setIsHover] = useState(false);

	if (tournament == null) {
		return null;
	}

	const { id: tournamentId } = tournament;

	const tournamentLookup = tournaments.get(tournamentId);
	const srSeasonId = tournamentLookup?.srSeasonId;

	if (srSeasonId == null) {
		return null;
	}

	const buttonCLasses = classNames(
		"jqLeagueStats offer__stats btn btn--square btn--square--reset",
		"btn--ghost"
	);

	const iconClasses = classNames(
		{
			"offer__stats__icon u-icon u-icon--sml":
				!customIconClassName || customIconClassName == undefined,
		},
		customIconClassName,
		{
			"u-icon--action--stats--active": !isHover && srSeasonId != null,
			"u-icon--action--stats--selected": isHover && srSeasonId != null,
			"u-icon--action--stats--disabled": srSeasonId == null,
		}
	);

	return (
		<button
			type="button"
			disabled={srSeasonId == null}
			onClick={() => openTournamentStatistics(srSeasonId)}
			onMouseEnter={() => setIsHover(true)}
			onMouseLeave={() => setIsHover(false)}
			className={customBtnClassName || buttonCLasses}
		>
			<i className={iconClasses} />
		</button>
	);
}
